import React from 'react';
import { SiteHeaderStyles } from './site-header.styles';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';
import LanguageChanger from './language-changer.component';
import Button from './button.component';
import { useTranslation } from 'react-i18next';

const SiteHeader = () => {
  const { t } = useTranslation('app');
  return (
    <SiteHeaderStyles>
      <div className={'logo'}>
        <Link to={'/'}>
          <img src={logo} alt={'logo'} />
        </Link>
      </div>
      <div className={'title'}>
        <span>{t('header.title')}</span>
        <span>{t('header.challenge')}</span>
      </div>

      <div className={'settings'}>
        <LanguageChanger />
        <a href={t('header.campaignLink')}>
          <Button>{t('header.toCampaign')}</Button>
        </a>
      </div>
    </SiteHeaderStyles>
  );
};

export default SiteHeader;
